import { render, staticRenderFns } from "./EditRequest.vue?vue&type=template&id=20496776"
import script from "./EditRequest.vue?vue&type=script&lang=js"
export * from "./EditRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports